import React from 'react';
import Header from '@/components/HeaderUpdated';
import Footer from '@/components/Footer';
import ContactForm from '@/components/ContactForm';
import { MapPin } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const Contact = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen flex flex-col bg-brand-darker text-white">
      <Header />
      
      <main className="flex-grow pt-32 pb-16">
        <section className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('contact.pageTitle')}</h1>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              {t('contact.pageSubtitle')}
            </p>
          </div>

          <div className="flex justify-center mb-12">
            {/* Contact Info Card - Only Location */}
            <div className="bg-brand-gray p-6 rounded-lg border border-gray-800 hover:border-brand-red transition-colors max-w-md w-full">
              <div className="flex items-center mb-4">
                <div className="bg-brand-red/10 p-3 rounded-full">
                  <MapPin className="text-brand-red" size={24} />
                </div>
                <h3 className="text-xl font-semibold ml-4">{t('contact.location')}</h3>
              </div>
              <p className="text-gray-400 mb-2">{t('contact.visitUs')}</p>
              <p className="text-white font-medium">
                Portugal
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <ContactForm />

          {/* Additional Info */}
          <div className="mt-16 text-center">
            <div className="bg-brand-gray p-8 rounded-lg border border-gray-800 max-w-2xl mx-auto">
              <h2 className="text-2xl font-bold mb-6">{t('contact.businessHours')}</h2>
              <div className="space-y-4 text-center">
                <div>
                  <p className="text-gray-400">{t('contact.mondayToFriday')}</p>
                  <p className="text-white font-semibold text-lg">09:00 - 18:00</p>
                </div>
                <div className="pt-4 border-t border-gray-700">
                  <p className="text-gray-400">{t('contact.responseTime')}</p>
                  <p className="text-white font-semibold">{t('contact.hoursResponse')}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
